import { SearchTerm } from "./SearchTerm";

const SequentialEventSearch: SearchTerm[] = [
    {
        heading: "All",
        accessor: "search",
        searchOnName: "search",
        translationKey: "all"
    },
    {
        heading: "Display Name",
        accessor: "personName",
        searchOnName: "personName",
        translationKey: "displayName"
    },
    {
        heading: "Card Number",
        accessor: "tagCode",
        searchOnName: "tagCode",
        translationKey: "cardNumber"
    },
    {
        heading: "Entry Reader",
        accessor: "entryReader",
        searchOnName: "entryReader",
        translationKey: "entryReader"
    },
    {
        heading: "Outcome Reader",
        accessor: "outcomeReader",
        searchOnName: "outcomeReader",
        translationKey: "outcomeReader"
    },
    {
        heading: "Site",
        accessor: "siteName",
        searchOnName: "siteName",
        translationKey: "site"
    },
    {
        heading: "Result",
        accessor: "result",
        searchOnName: "result",
        translationKey: "result"
    }
];

export default SequentialEventSearch;
